import { requests } from '../httpClient';

export const ReferenceData = {
    getReferenceDataAsync: () => requests.get(`ReferenceData`)
};
